import { api } from '../../lib/api';

/**
 * Where the studio publishes to.
 *
 * `path` is public - it is the host's username, and it is also where listeners
 * fetch from. `key` is not: it is write access to somebody's broadcast, and it
 * appears only inside `whip`. See `App\Domain\Station\StreamIngest` for why the
 * two are separate.
 *
 * Every one of these endpoints is behind the `studio` feature flag and answers
 * 404 when it is off, so a client that renders the studio anyway gets a 404
 * rather than a half-working broadcast.
 */
export interface StreamCredentials {
  path: string;
  key: string;
  /** POST an SDP offer here. Carries the key. */
  whip: string;
  /** What listeners fetch. */
  playback: string;
}

export const studio = {
  credentials: () => api.get<StreamCredentials>('/me/station/stream'),
  /** Invalidate the current key and mint a new one. */
  rotate: () => api.delete<StreamCredentials>('/me/station/stream'),
};
